<script setup lang="ts">
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import MxBalanceChip from './MxBalanceChip.vue';
import MxBottomTabs from './MxBottomTabs.vue';

const route = useRoute();
// Header is shown on the four root routes; detail pages get their own.
const showHeader = computed(() =>
  ['home', 'ideas', 'history', 'profile', 'create-video', 'create-image'].includes(
    String(route.name ?? ''),
  ),
);
const showTabs = computed(() => route.meta?.showTabs !== false);
</script>

<template>
  <header v-if="showHeader" class="hdr">
    <RouterLink to="/" class="logo">video.bot</RouterLink>
    <MxBalanceChip />
  </header>
  <main class="main">
    <RouterView />
  </main>
  <MxBottomTabs v-if="showTabs" />
</template>

<style scoped>
.hdr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  position: sticky;
  top: 0;
  background: var(--bg-base);
  z-index: 40;
}
.logo {
  font-family: var(--font-display);
  font-size: var(--fs-lg);
  font-weight: 600;
  color: var(--text-primary);
  letter-spacing: -0.01em;
}
.main {
  padding: 0 16px;
}
</style>
